<template>
  <b-modal
    ref="modal"
    :title="modalTitle"
    size="lg"
    ok-only
    ok-title="OK"
    header-bg-variant="success"
    header-text-variant="white"
  >
    <div v-if="result">
      <div class="text-center mb-4">
        <i class="fas fa-check-circle text-success" style="font-size: 4rem;"></i>
      </div>
      <b-card bg-variant="light" class="mb-3">
        <h6 class="text-primary mb-3">
          <i class="fas fa-info-circle mr-2"></i>
          Details
        </h6>
        <dl class="row mb-0">
          <dt class="col-sm-4">Clinic:</dt>
          <dd class="col-sm-8">{{ result.clinicCode }} - {{ result.clinicName }}</dd>
          <dt class="col-sm-4">Branch:</dt>
          <dd class="col-sm-8">{{ result.branchCode }} - {{ result.branchName }}</dd>
          <template v-if="result.userEmail">
            <dt class="col-sm-4">User:</dt>
            <dd class="col-sm-8">
              {{ result.userEmail }}
              <span v-if="result.isNewUser" class="badge badge-success ml-1">New</span>
              <span v-else class="badge badge-info ml-1">Linked</span>
            </dd>
          </template>
        </dl>
      </b-card>
      <b-card bg-variant="light">
        <h6 class="text-primary mb-3">
          <i class="fas fa-chart-bar mr-2"></i>
          Summary
        </h6>
        <b-row>
          <b-col sm="6">
            <ul class="list-unstyled mb-0">
              <li><i class="fas fa-door-open text-info mr-2"></i> Rooms created: <strong>{{ result.roomsCreated || 0 }}</strong></li>
              <li><i class="fas fa-syringe text-warning mr-2"></i> Treatments created: <strong>{{ result.treatmentsCreated || 0 }}</strong></li>
            </ul>
          </b-col>
          <b-col sm="6">
            <ul class="list-unstyled mb-0">
              <li><i class="fas fa-credit-card text-success mr-2"></i> Payment methods: <strong>{{ result.paymentMethodsCreated || 0 }}</strong></li>
              <li><i class="fas fa-shield-alt mr-2" :class="result.isNhso ? 'text-primary' : 'text-muted'"></i> NHSO: <strong>{{ result.isNhso ? 'Yes' : 'No' }}</strong></li>
            </ul>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'CreateResultModal',
  data() {
    return {
      result: null
    };
  },
  computed: {
    modalTitle() {
      if (!this.result) return '';
      return this.result.branchNo ? 'Branch Created Successfully!' : 'Clinic Created Successfully!';
    }
  },
  methods: {
    show(result) {
      this.result = result;
      this.$refs.modal.show();
    }
  }
};
</script>
